"use strict";
const _ = require('lodash');
const formatInvoiceRows = invoice => {
    for (let i = 0; i < invoice.invoiceRows.length; i++) {
        const row = invoice.invoiceRows[i];
        if (row.article) {
            const article = row.article;
            if (!article.utilityArticle) {
                row.name = `${article.supplierArticleNumber || ''} ${article.name}`
                    .substr(0, 50)
                    .trim();
                const colliSize = article.colliSize || 1;
                const colliSpec = `(${row.deliveredQuantity / colliSize}x${colliSize})`;
                row.name =
                    _.padEnd(row.name.substr(0, 50 - colliSpec.length), 50 - colliSpec.length, ' ') + colliSpec;
            }
        }
    }
};
const removeAlcoholTaxOnRows = invoice => {
    for (let i = 0; i < invoice.invoiceRows.length; i++) {
        const row = invoice.invoiceRows[i];
        if (row.article) {
            const article = row.article;
            if (article.alcoholTax) {
                row.price -= article.alcoholTax;
            }
        }
    }
};
module.exports = {
    formatInvoiceRows,
    removeAlcoholTaxOnRows,
};
